import React from 'react';
import { Typography, Box } from '@mui/material';

const ResultsPage: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        Results Import
      </Typography>
      <Typography variant="body1">
        Results page - Coming soon...
      </Typography>
    </Box>
  );
};

export default ResultsPage;